<template>
  <div :class="{layout: true, active: expanded, closed: !expanded}">
    <div class="content">
      <div class="scrollable">
        <slot name="content" />
      </div>
    </div>
    <div class="sidebar">
      <div class="sidebar-nav">
        <slot name="sidebarNav" />
      </div>
      <div class="sidebar-right" v-show="expanded">
        <div class="sidebar-content scrollable">
          <slot name="questions" />
        </div>
        <transition>
          <slot name="bottom" class="bottom" />
        </transition>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'BlastStudentLayout',
    props: {
      expanded: {
        type: Boolean
      }
    }
  }
</script>

<style lang="scss" scoped>

  @import "~globals";

  .layout {
    display:flex; height:calc(100vh - #{$header-height}); overflow:hidden; position:relative;
  }

  .content {
    display:flex; flex:1; flex-shrink:1; -ms-flex:auto;
  }

  .sidebar {
    display:flex; box-shadow:0 2px 4px 1px rgba($color-black, .5); position:relative; z-index:2;
    .active & {
      @include media(xlarge) {
        min-width:500px; width:40%;
      }
    }
    @include media(small,xlarge) {
      .active & {
        @include position(absolute, 0 0 0 0); z-index:9;
      }
    }
  }

  .sidebar-right {
    display:flex; flex-direction:column-reverse; width:calc(100% - #{$sidebar-menu-width});
    @include media(xlarge) {
      flex-direction:column;
    }
  }

  .scrollable {
    overflow-y:scroll; -webkit-overflow-scrolling: touch; width:100%;
  }

  .sidebar-nav {
    background:lighten($color-primary-darker, 10%);
  }

  .sidebar-content {
    flex:1; width:100%; padding:4rem 2rem; background:$color-gray-background; color:$color-black; position:relative;
  }

  .bottom {
    position:relative;
    &.v-leave-to {
      transform:translateY(100%);
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/BlastStudent/Layout.vue